import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';
import { fullNamePresenter } from 'utils';

import type { IAdminPanelAgencyDoctorsResponse } from 'infrastructure/interfaces';

interface IDataProps {
  searchValue: string;
  searchKey: string;
  status?: string;
  roleName?: string;
}

const aminPanelSearchAgencyDoctorsFn = async ({
  searchKey,
  searchValue,
  status,
  roleName,
}: IDataProps) => {
  const { data, error } =
    await dataService.getList<IAdminPanelAgencyDoctorsResponse>(
      apiUrlGenerator('admins/admin-panel/agency-doctors', {
        [searchKey]: searchValue,
        status,
        roleName,
      }),
    );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  const preparedData =
    data?.items?.map((patient) => ({
      value: patient.guid,
      label: fullNamePresenter(patient),
    })) ?? [];

  if (data) {
    return preparedData;
  }
};

export const useAminPanelSearchAgencyDoctor = () => {
  const { mutate, data, isLoading, ...other } = useMutation({
    mutationFn: aminPanelSearchAgencyDoctorsFn,
  });

  return {
    searchDoctor: mutate,
    doctors: data,
    searchDoctorLoading: isLoading,
    ...other,
  };
};
